import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import tools from "../../../helpers/tools";
import Badge from "../Badge/Badge";

const CompanyInfo = ({
  isHeadOffice,
  noBadge,
  company,
  siret,
  infos = [],
  showCompanyLink = true,
  isOpened = false,
  className = "",
  badgeText = "",
  companyStatus = "",
}) => {
  return (
    <StyledCompanyInfo className={className}>
      {!noBadge && (
        <Badge
          color="default"
          style={{
            fontSize: 15,
            background: isHeadOffice ? "#040ca5" : "#9C9C9C",
            color: "white",
          }}
        >
          {badgeText ? badgeText : isHeadOffice ? "Siège" : "Établissement"}
        </Badge>
      )}
      <div className="info__company position-relative d-flex align-items-start justify-content-start flex-row">
        {showCompanyLink ? (
          <Link
            className="pt-1 mr-1 company__link"
            title="Ouvrir la société dans un nouvel onglet"
            to={`/client-list?sirenOuSiret=${siret}`}
            target="_blank"
          >
            {company}{" "}
            <i
              style={{ fontSize: 9 }}
              className="fa fa-external-link-alt ml-1"
            ></i>
          </Link>
        ) : (
          company
        )}
      </div>
      <div className="info__siret" data-value={siret}>
        {tools.formatFollowingPattern(siret, [3, 3, 3, 5], " ")}
      </div>
      <div className="info__status">{companyStatus}</div>
      <details open={isOpened}>
        <summary className={`text-primary ${isOpened ? "d-none" : ""}`}>
          {isOpened ? "" : "Résumé"}
        </summary>
        <div>
          {infos.map((info, ik) => (
            <div
              className="info__item"
              data-value={typeof info == "string" ? info : ""}
              key={`inf${ik}`}
              title={typeof info == "string" ? info : ""}
            >
              {info}
            </div>
          ))}
        </div>
      </details>
    </StyledCompanyInfo>
  );
};

const StyledCompanyInfo = styled.div`
  & .company__link {
    font-size: 12px;
    /* position: absolute; */
    z-index: 999;
    display: inline-flex;
    color: var(--color-primary);
    font-size: 16px;
  }
  & .info__company {
    /* overflow: hidden; */
    width: 100%;
    max-width: 100%;
    font-size: 18px;
    font-weight: 800;
  }
  & .info__siret {
    font-size: 15px;
    color: #686262;
  }

  & .info__item {
    font-size: 12.5px;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    overflow: hidden;
  }

  & .info__status {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding: 3px 0;
  }
`;

export default CompanyInfo;
